import { useMemo, useState } from 'react';
import { commitNumberInput, clamp, handleRangeIntChange } from './helpers.js';
import FitFacts from './FitFacts.js';

const calculateTargetHeartRange = (age) => {
	const beginnerLow = (208 - (0.7 * age)) * 0.6;
	const beginnerHigh = (208 - (0.7 * age)) * 0.74;

	const intermediateLow = (208 - (0.7 * age)) * 0.75;
	const intermediateHigh = (208 - (0.7 * age)) * 0.84;

	const advancedLow = (208 - (0.7 * age)) * 0.85;
	const advancedHigh = (208 - (0.7 * age)) * 0.94;

	return {
		beginner: `${beginnerLow.toFixed(1)} - ${beginnerHigh.toFixed(1)} bpm`,
		intermediate: `${intermediateLow.toFixed(1)} - ${intermediateHigh.toFixed(1)} bpm`,
		advanced: `${advancedLow.toFixed(1)} - ${advancedHigh.toFixed(1)} bpm`
	};
};

export default function HeartRate() {
	const [age, setAge] = useState(43);
	const [ageInput, setAgeInput] = useState('43');
	const results = useMemo(() => calculateTargetHeartRange(age), [age]);

	return (
		<div className="calc-container-scroller">
			<div className="calc-container-scroller-inner">
				<div className="calculator-wrap">
					<h3>Find Your Target Heart Rate Range</h3>

					<div className="calculator-row">
						<div className="range-row">
							<div className="range-row__input-wrap">
								<input
									id="range-age"
									type="range"
									min="10"
									max="100"
									value={age}
									onChange={(e) => handleRangeIntChange(e, setAge, setAgeInput)}
								/>
							</div>

							<div className="range-row__result-wrap">
								<label htmlFor="input-age">Age: </label>
								<input
									type="number"
									id="input-age"
									name="input-age"
									value={ageInput}
									onChange={(e) => setAgeInput(e.target.value)}
									onKeyUp={(e) => handleArrowCommit(e, 10, 100, age, setAge, setAgeInput)}
									onBlur={() => commitNumberInput(ageInput, 10, 100, age, setAge, setAgeInput)}
								/>
							</div>
						</div>
					</div>

					<div className="spc-m-y-2">
						<p>Your target heart rate range (in beats per minute) is:</p>
						<table>
							<tbody>
								<tr>
									<td><label htmlFor="result_beginner">Beginner: </label></td>
									<td>
										<input
											type="text"
											id="result_beginner"
											name="result_beginner"
											value={results.beginner}
											readOnly
											style={{ textAlign: 'center', fontSize: '15px', fontWeight: 'bold' }}
										/>
									</td>
								</tr>

								<tr>
									<td><label htmlFor="result_intermediate">Intermediate: </label></td>
									<td>
										<input
											type="text"
											id="result_intermediate"
											name="result_intermediate"
											value={results.intermediate}
											readOnly
											style={{ textAlign: 'center', fontSize: '15px', fontWeight: 'bold' }}
										/>
									</td>
								</tr>

								<tr>
									<td><label htmlFor="result_advanced">Advanced: </label></td>
									<td>
										<input
											type="text"
											id="result_advanced"
											name="result_advanced"
											value={results.advanced}
											readOnly
											style={{ textAlign: 'center', fontSize: '15px', fontWeight: 'bold' }}
										/>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

                    <FitFacts
                        items={[
                            {
                                label: 'Small Steps To Increase Physical Activity',
                                link: '/images/webcontent/assets/education-resources/lifestyle/fitfacts/pdfs/fitfacts/itemid_3577.pdf'
                            }
                        ]}
                    />
				</div>
			</div>
		</div>
	);
}
